const IPIFY_URL = "https://api.ipify.org?format=json";
const IPAPI_CLIENT_URL = "https://ipapi.co/json/";
const IPAPI_URL = (ip: string) => `https://ipapi.co/${encodeURIComponent(ip)}/json/`;
const IPWHO_ROOT = "https://ipwho.is/";
const IPWHO_FOR_IP = (ip: string) => `https://ipwho.is/${encodeURIComponent(ip)}`;

async function fetchJson<T>(url: string, signal: AbortSignal): Promise<T> {
  const res = await fetch(url, { signal });
  if (!res.ok) throw new Error(`HTTP ${res.status}`);
  return res.json() as Promise<T>;
}

async function resolveCountryForIp(ip: string, signal: AbortSignal): Promise<string> {
  try {
    const geo = await fetchJson<{
      error?: boolean;
      reason?: string;
      country_name?: string;
    }>(IPAPI_URL(ip), signal);
    if (!geo?.error) {
      const c = String(geo?.country_name ?? "").trim();
      if (c) return c;
    }
  } catch {
    /* try ipwho */
  }

  try {
    const who = await fetchJson<{
      success?: boolean;
      country?: string;
    }>(IPWHO_FOR_IP(ip), signal);
    if (who?.success !== false) {
      const c = String(who?.country ?? "").trim();
      if (c) return c;
    }
  } catch {
    /* */
  }

  return "";
}

export async function fetchClientIpAndCountry(signal: AbortSignal): Promise<{
  ip_address: string;
  country: string;
}> {
  let ip = "";
  try {
    const ipJson = await fetchJson<{ ip?: string }>(IPIFY_URL, signal);
    ip = String(ipJson?.ip ?? "").trim();
  } catch {
    /* fall through to bundled providers */
  }

  if (ip) {
    const country = await resolveCountryForIp(ip, signal);
    return { ip_address: ip, country };
  }

  try {
    const who = await fetchJson<{
      success?: boolean;
      ip?: string;
      country?: string;
    }>(IPWHO_ROOT, signal);
    if (who?.success && who.ip && who.country) {
      return {
        ip_address: String(who.ip).trim(),
        country: String(who.country).trim(),
      };
    }
  } catch {
    /* try ipapi client */
  }

  try {
    const direct = await fetchJson<{
      error?: boolean;
      reason?: string;
      ip?: string;
      country_name?: string;
    }>(IPAPI_CLIENT_URL, signal);
    if (!direct?.error && direct.ip && direct.country_name) {
      return {
        ip_address: String(direct.ip).trim(),
        country: String(direct.country_name).trim(),
      };
    }
  } catch {
    /* */
  }

  return { ip_address: "", country: "" };
}
